<template>
  <div class="app">
    <!-- <Background /> -->
    <router-view />
  </div>
</template>

<script>
// import Background from '@/components/Background.vue'


export default {
  name: 'app',
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
  color: white;
  list-style: none;
  text-decoration: none;
}

section {
  padding: 0 15%;
  margin-top: 2rem;

  @media(max-width: 990px) {
    padding: 50px 10%;
  }

  @media(max-width: 750px) {
    margin-top: 0;
  }
}

.app {
  min-height: 100vh;
  background: rgba(219, 219, 219, 0.692);
  user-select: none;
  background: black;

  @media (min-width: 900px) {
    flex-direction: row !important;
  }

  .app-content {
    padding: 80px 20px;
    flex: 1;
    position: relative;

    @media (min-width: 900px) {
      padding: 0 90px;
    }
  }
}

::-webkit-scrollbar {
  display: none;
}

.active {
  text-shadow: 0 0 10px rgba(13, 0, 0, 1),
    0px 0px 21px rgba(13, 0, 0, 0.78),
    0px 0px 24px rgba(13, 0, 0, 0.82),
    0px 1px 4px rgba(13, 0, 0, 0.16);
}

.dark-mode {
  .active {
    text-shadow: 0 0 10px rgba(255, 255, 255, 1),
      0 0 20px rgba(255, 255, 255, 0.8),
      0 0 30px rgba(255, 255, 255, 0.6),
      0 0 40px rgba(255, 255, 255, 0.4);
  }
}

.dark-mode {
  color: white;

  p {
    color: rgb(126, 126, 126);
  }

  .intro {
    h1 {
      color: white;
    }
  }
}


p {
  color: rgb(68, 68, 68);
}


html {
  scroll-behavior: smooth;
  -webkit-tap-highlight-color: transparent;

  @media(max-width: 750px) {
    box-shadow: none;
  }

  @media (max-width: 520px) {
    font-size: 85%;
  }
}



// p {
//   color: rgb(126, 126, 126);
// }

a,
.btn {
  transition: all 300ms ease;
}

.index {
  z-index: 1000;
}

.flex {
  display: flex;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.intro {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin-top: 10rem;
  margin-bottom: 6rem;
  text-align: center;

  p {
    font-size: 1.3rem;
  }

  h1 {
    font-size: 1.8rem;
    color: black;
  }


  @media(max-width: 990px) {
    margin-top: 5rem;
  }
}

.sbtn {
  background: #948e8e;
  color: white;
}

.cbtn {
  background: rgb(39, 150, 39);
  color: white;
}

.dbtn {
  background: rgb(243, 79, 79);
  color: white;
}

.obtn {
  background: rgb(235, 42, 42);
  color: white;
}

.wbtn {
  background: rgb(219, 218, 218);
  color: black;
}

.completed {
  &::before {
    background-color: #46d633;
  }

  color: black;
  background-color: rgba(130, 214, 45, 0.788);
}

.pending {
  &::before {
    background-color: #e2764b;
  }

  color: black;
  background-color: rgb(231, 174, 69);
}

.declined {
  &::before {
    background-color: red;
  }

  color: black;
  background-color: rgb(224, 62, 62);
}

.status {
  &::before {
    content: "";
    width: 10px;
    height: 10px;
    border-radius: 50%;
    // margin-right: 8px;
  }

  font-size: 13px;
  // margin-right: 30px;
  align-items: center;
  padding: .8rem 1rem;
  border-radius: 10px;
}</style>
